export function random(min, max) {
  return Math.random() * (max - min) + min;
}

export function map(n, in_min, in_max, out_min, out_max) {
  return ((n - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
}

export function sample(array) {
  return array[Math.floor(Math.random() * array.length)];
}

export function shuffle(array) {
  return [...array].sort(() => 0.5 - Math.random());
}

export function clamp(n, min, max) {
  return Math.min(Math.max(n, min), max);
}

export function average(array, take) {
  if (!take) take = array.length;
  var sum = 0;
  var lastElements = array.slice(Math.max(array.length - take, 1));
  for (var i = 0; i < lastElements.length; i++) {
    sum = sum + lastElements[i];
  }
  return sum / take;
}

export function sum(array) {
  return array.reduce((acc, curr) => {
    return acc + curr.value;
  }, 0);
}
